
import {initWebComponent} from "@/helpers/web-component-helper";
import {bytesToSize} from "@/helpers/file-helper";
import {
    getAttributeItemByFeatureInfo,
    getFeatureInfoByFeatureInfoKey
} from "@/helpers/plugin-helper";
import {retrieveLnk} from "@/http/services/plugin/http-services-plugin-kavel10";

export class LayerInfoInfoPluginKavel10Component extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        const featureInfoKey = this.getAttribute('data-feature-info-key')
        const featureKey = this.getAttribute('data-feature-key')

        const featureInfo = getFeatureInfoByFeatureInfoKey(featureKey, featureInfoKey)

        const coordinates = featureInfo.records[0].geometry.coordinates

        retrieveLnk(coordinates[0], coordinates[1]).then( result => {

            let url = result.Url
            if(result.linkID) {
                url = 'https://kavel10.obliquo.cloud/?e=' + result.linkID
            }

            let innerHTML = ``
            innerHTML += `
                <div class="embed-responsive embed-responsive-4by3 h-100">
                    <iframe 
                        class="embed-responsive-item" 
                        seamless=""
                         allowtransparency="true" 
                         allowfullscreen="" 
                        src="` + url + `">
                    </iframe>
                </div>
          
                `;

            template.innerHTML = innerHTML

            initWebComponent(this, template)
        })

    }
}

